enum AudienceInputOption {
  FreeformWalletInput = "FreeformWalletInput",
  SimpleAudienceInput = "SimpleAudienceInput",
}

export default AudienceInputOption;
